import { useLazyGetChartsQuery } from '@api/chart';
import { updateConfigs } from '@pages/ProjectBoard/slice';
import { RootState } from '@store/store';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useProjects = ({ pollingInterval, pollingCallBack }: any) => {
  const projectBoard = useSelector((state: RootState) => state?.projectBoard);
  const dispatch = useDispatch();

  const [isProjectBoardEmpty, setProjectBoardEmpty] = useState<boolean>(false);

  const [getCharts, { isLoading }] = useLazyGetChartsQuery(
    pollingInterval
      ? {
          pollingInterval: pollingInterval,
          selectFromResult: ({ data, isLoading }) => {
            if (data?.length) pollingCallBack(data, projectBoard.configs);

            return { data, isLoading };
          }
        }
      : {}
  );

  const getChartConfigs = async ({
    projectId,
    collaboration_id = ''
  }: {
    projectId: string;
    collaboration_id: string;
  }) => {
    try {
      if (projectId) {
        const response = await getCharts({
          id: projectId,
          collaboration_id: collaboration_id
        }).unwrap();

        if (response) {
          dispatch(updateConfigs(response));
          if (
            !response.length &&
            projectBoard.currentProjectData?.auto_charts_executed
          )
            setProjectBoardEmpty(true);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    getChartConfigs,
    chartConfigs: projectBoard.configs,
    isLoading,
    isProjectBoardEmpty
  };
};

export default useProjects;
